module.exports = __webpack_public_path__ + "static/drone-075581a44e2a2ae423881151e2d0c99b.png";